import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { CreateBestellungRequest, CreateBestellungResponse } from '@/types/bestellung';

export function useCreateBestellung() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: CreateBestellungRequest) =>
      apiFetch<CreateBestellungResponse>('/bestellungen/create.php', {
        method: 'POST',
        body: JSON.stringify(req)
      }),
    onSuccess: () => {
      // Cache fuer Dashboard/Kanban (kommen spaeter) bereits jetzt
      // invalidieren, damit wir nach dem Bau dieser Listen nicht alle
      // Aufrufer nachruesten muessen.
      qc.invalidateQueries({ queryKey: ['bestellungen'] });
    }
  });
}
